import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon_delete",
  "use": "icon_delete-usage",
  "viewBox": "0 0 15 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 15 16\" id=\"icon_delete\"><path d=\"M1 4.083h12.75m-11.333 0V14c0 .782.634 1.417 1.416 1.417h7.084c.782 0 1.416-.635 1.416-1.417V4.083m-7.791 0V2.667c0-.783.634-1.417 1.416-1.417h2.834c.782 0 1.416.634 1.416 1.417v1.416M8.791 7.625v4.25M5.958 7.625v4.25\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol